import { render, staticRenderFns } from "./EditOrderDetailProductForm.vue?vue&type=template&id=18005f96&scoped=true"
import script from "./EditOrderDetailProductForm.vue?vue&type=script&lang=js"
export * from "./EditOrderDetailProductForm.vue?vue&type=script&lang=js"
import style0 from "./EditOrderDetailProductForm.vue?vue&type=style&index=0&id=18005f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18005f96",
  null
  
)

export default component.exports